module.exports = __webpack_public_path__ + "img/chz-logo-round.f2991ffe.webp";